"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Theme = require("../Theme");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Dialog = {
  styles: function styles(theme) {
    return {
      defaultDialogBoxStyles: {
        borderRadius: 8,
        padding: theme.spacing.base * 3
      },
      title: {
        color: theme.colors.baseContrast070,
        fontSize: theme.typography.fontSize + 4
      },
      svgIcon: {
        width: 20,
        height: 20,
        minHeight: 20,
        minWidth: 20
      },
      content: {
        fontSize: theme.typography.fontSize
      },
      button: {
        textTransform: "none",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: theme.colors.baseContrast030,
        fontSize: theme.typography.fontSize + 1,
        "& label": {
          color: theme.colors.baseContrast090
        },
        "&:last-child > label": {
          color: theme.mode === _Theme.ThemeMode.dark ? theme.colors.textOnLight : theme.colors.textOnDark
        },
        "&:last-child": {
          background: theme.mode === _Theme.ThemeMode.dark ? theme.colors.textOnDark : theme.colors.textOnLight,
          "&:hover, &:focus-visible": {
            background: theme.colors.baseContrast070
          }
        }
      }
    };
  }
};
var _default = exports.default = Dialog;